import React from "react";
import { icons } from "../../assets/icons";

const Security = () => {
  return (
    <div className="flex justify-between flex-wrap py-2 gap-x-20">
      <div className="flex-1">
        <div>
          <div className="font-size-small text-[var(--blackColor)]">
            Password
          </div>
          <div className="font-size-small text-[var(--textGray3)]">
            Last changed 3 months ago
          </div>
        </div>
        <div className="flex items-center gap-x-2 h-fit mt-3">
          <img
            src={icons.loopIcon}
            className="w-[2.4rem] h-[1.8rem]"
            alt="change password"
          />
          <div className="font-size-small text-[var(--textRed)] underline">
            Change Password
          </div>
        </div>

        <div className="h-[1px] w-100 bg-[var(--borderGray1)] my-5" />

        <div className="font-size-small">Devices Sign-in</div>
        <div className="flex border-[1px] border-color-[var(--borderGray1)] rounded-[0.6rem] mt-4">
          <img src={icons.laptopIcon} className="p-3" alt="laptop icon" />
          <div className="font-size-small mt-2 mb-4">
            <div>Desktop/Laptop | Windows</div>
            <div>29 Jul 2023 | Gurugram</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security;
